var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 25.6667H11.9998C12.1776 25.6667 12.3332 25.6 12.4665 25.4667C12.5998 25.3333 12.6665 25.1778 12.6665 25C12.6665 24.8222 12.5998 24.6667 12.4665 24.5333C12.3332 24.4 12.1776 24.3333 11.9998 24.3333H7.99984C7.82206 24.3333 7.6665 24.4 7.53317 24.5333C7.39984 24.6667 7.33317 24.8222 7.33317 25C7.33317 25.1778 7.39984 25.3333 7.53317 25.4667C7.6665 25.6 7.82206 25.6667 7.99984 25.6667ZM3.33317 29.6667C2.59984 29.6667 1.97228 29.4058 1.4505 28.884C0.927837 28.3613 0.666504 27.7333 0.666504 27V3.00001C0.666504 2.26668 0.927837 1.63868 1.4505 1.11601C1.97228 0.594232 2.59984 0.333344 3.33317 0.333344H16.6665C17.3998 0.333344 18.0278 0.594232 18.5505 1.11601C19.0723 1.63868 19.3332 2.26668 19.3332 3.00001V27C19.3332 27.7333 19.0723 28.3613 18.5505 28.884C18.0278 29.4058 17.3998 29.6667 16.6665 29.6667H3.33317ZM3.33317 20.3333H16.6665V7.00001H3.33317V20.3333Z",
    fill: "#8DAA6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberIcon);
export default __webpack_public_path__ + "static/media/phoneNumberIcon.138c9e6f8b7f306d788015c8697d609a.svg";
export { ForwardRef as ReactComponent };